import { FieldController, NameValidator, TextField, TextArea } from '@keplerco/core';
import React from 'react';
import { WidgetCard } from '../../analytics/analytics-filters/widget-card';
import { Control } from 'react-hook-form';

export function DetailsWidget({ control }: { control: Control }): JSX.Element {

  return (
    <WidgetCard title="Details" subtitle="Name your assessment, this will be displayed to participants">
      <FieldController
        name="name"
        control={control}
        rules={new NameValidator()}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            label="Name"
            type="text"
            validation={{
              dirty: fieldState.isDirty || !!fieldState.error,
              invalid: !!fieldState.error,
              message: fieldState.error?.message ?? 'Enter a name',
            }}
            responsive
          />
        )}
      />

      <FieldController name="description" control={control} render={({ field }) => <TextArea {...field} label="Description (optional)" responsive />} />
    </WidgetCard>
  );
}